import { useState, useContext } from "react"
import { getCollectionDocs, updateData } from "../../firebase/firebase_functions";
import { AppContext } from "../../contextApi/ContextApi";
import Modal from "../Modal";
import AdminSelectEdit from "./AdminSelectEdit";

export default function AdminWebsiteCard({admin, website, theme}) {
    const {setToastMessage, messagesOptions, setCurrentManager} = useContext(AppContext);
    const [isHoverPlay, setIsHoverPlay] = useState(false);
    const [isHoverDelete, setIsHoverDelete] = useState(false);
    const [isHoverChange, setIsHoverChange] = useState(false);
    const [activityStatus, setActivityStatus] = useState(website?.settings?.isActive);
    const [deleteFlag, setDeleteFlag] = useState(false);
    const [deleteModalFlag, setDeleteModalFlag] = useState(false);
    const [EditModalFlag, setEditModalFlag] = useState(false);

    const updateActivity = async()=>{
        const res = await updateData(website.id, "settings.isActive", !activityStatus ,false);
        if(res){
            const websites = await getCollectionDocs("websites");
            setCurrentManager({
                name:"Admin",
                email:admin.email,
                uid:admin.uid,
                websites,
                clients: websites.map((site)=>{
                    return {...site.owner, websiteID: site.id}
                })
            });
            setActivityStatus(!activityStatus);
            // const updatedWebsites = admin?.websites.map((obj)=>{
            //     if(obj.id===website.id){
            //         obj.settings.isActive = !activityStatus;
            //     }
            //     return obj;
            // })
            // admin.websites = updatedWebsites;
            // localStorage.setItem("webingo_currentManager", JSON.stringify(admin));
        }
        else{
            setToastMessage(messagesOptions.adminFailedMsg);
        }
    }


    const userCompleteDelete = async()=>{
        setDeleteFlag(true);
        try {
            
            const res = await fetch(
            `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECTID}.cloudfunctions.net/adminDeleteUserResources`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        websiteID: website.id,
                        userUID: website.owner.uid,
                    }),
                }
            );
            const data = await res.json();
            
            if(data.success){
                const websites = await getCollectionDocs("websites");
                setCurrentManager({
                    name:"Admin",
                    email:admin.email,
                    uid:admin.uid,
                    websites,
                    clients: websites.map((site)=>{
                        return {...site.owner, websiteID: site.id}
                    })
                });
                // const updatedWebsites = admin?.websites.filter(obj => obj.id!==website.id)
                // admin.websites = updatedWebsites;
                // await new Promise(resolve => setTimeout(resolve, 1500))
                // localStorage.setItem("webingo_currentManager", JSON.stringify(admin));
                setToastMessage(messagesOptions.adminDeleteWebsiteMsg);
            }
        } catch (error) {
            console.error("Error delete website at admin dashboard: ",error);
            setToastMessage(messagesOptions.adminFailedMsg);
        } finally{
            setDeleteFlag(false);
        }
    }
    
    return (
        <div className='adminWebsiteContainer' style={{backgroundColor:theme?.accent_color, border:`0.5px solid ${theme?.primary_color}`}}>
            {deleteModalFlag && <Modal title={"פעולה זו תמחק את האתר והמשתמש לחלוטין."} children={<p dir="rtl" style={{color:theme?.primary_color}}>להמשיך?</p>} onCancel={()=>{setDeleteModalFlag(false)}} onConfirm={()=>{setDeleteModalFlag(false);userCompleteDelete()}} isDashboard={true} theme={theme}/>}
            {EditModalFlag && <Modal title={"מה ברצונך לבצע באתר זה?"} children={<AdminSelectEdit website={website} theme={theme}/>} isDashboard={true} theme={theme} onCancel={()=>{setEditModalFlag(false)}} onConfirm={()=>{setEditModalFlag(false)}}/>}{/*add the save changes function here*/}

            <div className="adminWebsiteCard">
                <div className="adminWebsiteCard_controller" style={{color:theme?.primary_color}}>
                    <div className="adminWebsiteCard_controllerBtn" onMouseEnter={()=>{setIsHoverPlay(true)}} onMouseLeave={()=>{setIsHoverPlay(false)}}>
                        <p className="adminWebsiteCard_controllerBtn_header">{isHoverPlay ? `${activityStatus ? "Suspend":"Start"}` : ""}</p>
                        <p className="adminWebsiteCard_controllerBtn_icon" onClick={updateActivity}>{!activityStatus ? "▶" : "⏸"}</p>
                    </div>
                    <div className="adminWebsiteCard_controllerBtn" onMouseEnter={()=>{setIsHoverDelete(true)}} onMouseLeave={()=>{setIsHoverDelete(false)}}>
                        <p className="adminWebsiteCard_controllerBtn_header">{isHoverDelete&&!deleteFlag ? "Delete" : ""}</p>
                        <button disabled={deleteFlag} style={{width:"100%", backgroundColor:"transparent", border:"none", color:theme.primary_color}} className="adminWebsiteCard_controllerBtn_icon" onClick={()=>{setDeleteModalFlag(true)}}>🗑</button>
                    </div>
                    {/* <div className="adminWebsiteCard_controllerBtn" onMouseEnter={()=>{setIsHoverChange(true)}} onMouseLeave={()=>{setIsHoverChange(false)}}>
                        <p className="adminWebsiteCard_controllerBtn_header">{isHoverChange ? "Edit" : ""}</p>
                        <p className="adminWebsiteCard_controllerBtn_icon" onClick={()=>{setEditModalFlag(true)}}>✎</p>
                    </div> */}
                </div>
                <div className='adminWebsiteCard_left'>
                    <div className='adminWebsiteCard_iframeContainer' style={{border:`0.5px solid ${theme?.primary_color}`}}>
                        <iframe key={activityStatus} src={`/${website?.settings?.domain}/home`} className='adminWebsiteCard_iframe' loading='lazy' scrolling='no'/>
                        <a className='adminWebsiteCard_blockInteractDiv' aria-hidden="true" href={`/${website?.settings?.domain}/home`} target='_blank' rel="noreferrer"/>
                    </div>
                </div>
                <div className='adminWebsiteCard_right' style={{color:theme?.primary_color}}>
                    <div className="adminWebsiteCard_right_details">
                        <p className="adminWebsiteCard_right_details_subject">שם האתר:</p>
                        <p className="adminWebsiteCard_right_details_content">{website?.settings?.website_name}</p>
                    </div>
                    <div className="adminWebsiteCard_right_details">
                        <p className="adminWebsiteCard_right_details_subject">בעל האתר:</p>
                        <p className="adminWebsiteCard_right_details_content">{website?.owner?.name}</p>
                    </div>
                    <div className="adminWebsiteCard_right_details">
                        <p className="adminWebsiteCard_right_details_subject">דומיין:</p>
                        <p className="adminWebsiteCard_right_details_content">{website?.settings?.domain}</p>
                    </div>
                    <div className='adminWebsiteCard_details' dir='rtl'>
                    </div>
                </div>
            </div>
        </div>
    )
}
